<template>
  <!-- NOTE (TEMPLATE) to show the refree archive -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/referee/archive'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-archive) to show the refree archive list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="computedItems"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="هنوز طرحی ثبت نشده است"
        striped
        :busy="isBusy"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>

        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + perPage * (currentPage - 1) + 1 }}
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      fields: [
        { key: "index", label: "ردیف" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "type", label: "نوع حمایت" },
        { key: "judgeCode", label: "کد داوری" },
        { key: "judgeDecision", label: "نظر داور" },
        { key: "judgeDate", label: "تاریخ داوری" },
      ],
      // items: [{ faSubject: 'test1' , project_status: 'نیاز به تکمیل'}, { faSubject: 'test2', project_status: 'ثبت شده' }],
      items: [],
      filter: "",
      isBusy: true,
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
    };
  },
  computed: {
    computedItems() {
      if (this.items) {
        return this.items.sort((a, b) => {
          if (a.time < b.time) {
            return 1;
          }
          if (a.time > b.time) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else return [];
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      this.$http
        .post(
          this.baseUrl + "/setad/reviewer/reviews/archives",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.isBusy = false;
          this.totalRows = this.items.length;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });
    },
  },
  mounted() {
    this.onMounted();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
